import { render, staticRenderFns } from "./nowSales.vue?vue&type=template&id=5382417c&scoped=true"
import script from "./nowSales.vue?vue&type=script&lang=js"
export * from "./nowSales.vue?vue&type=script&lang=js"
import style0 from "./nowSales.vue?vue&type=style&index=0&id=5382417c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5382417c",
  null
  
)

export default component.exports